import fns from '../../utils/fns';
import { INVALID_ATTRIBUTES, UNDEFINED_ATTRIBUTE } from 'error_message';
import { OptimizelyError } from '../../error/optimizly_error';
/**
 * Validates user's provided attributes
 * @param  {unknown}  attributes
 * @return {boolean}  true if the attributes are valid
 * @throws If the attributes are not valid
 */
export function validate(attributes) {
    if (typeof attributes === 'object' && !Array.isArray(attributes) && attributes !== null) {
        Object.keys(attributes).forEach(function (key) {
            if (typeof attributes[key] === 'undefined') {
                throw new OptimizelyError(UNDEFINED_ATTRIBUTE, key);
            }
        });
        return true;
    }
    else {
        throw new OptimizelyError(INVALID_ATTRIBUTES);
    }
}
/**
 * Validates user's provided attribute
 * @param  {unknown}  attributeKey
 * @param  {unknown}  attributeValue
 * @return {boolean}  true if the attribute is valid
 */
export function isAttributeValid(attributeKey, attributeValue) {
    return (typeof attributeKey === 'string' &&
        (typeof attributeValue === 'string' ||
            typeof attributeValue === 'boolean' ||
            (fns.isNumber(attributeValue) && fns.isSafeInteger(attributeValue))));
}
export const __platforms = ['__universal__'];
//# sourceMappingURL=index.js.map